var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	50318: () => (loadSingletonVersion("default", "react", false, [1,18,3,1], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	85302: () => (loadSingletonVersion("default", "@emotion/react", false, [1,11,10,5], () => (Promise.all([__webpack_require__.e(4300), __webpack_require__.e(2389), __webpack_require__.e(5487)]).then(() => (() => (__webpack_require__(17437))))))),
	36070: () => (loadSingletonVersion("default", "@emotion/styled", false, [1,11,10,5], () => (__webpack_require__.e(3144).then(() => (() => (__webpack_require__(70763))))))),
	61073: () => (loadStrictVersion("default", "@moodys/mdc-frontend.services.logger", false, [2,0,6,5], () => (Promise.all([__webpack_require__.e(1083), __webpack_require__.e(579), __webpack_require__.e(8618)]).then(() => (() => (__webpack_require__(68618))))))),
	21150: () => (loadSingletonVersion("default", "@mui/material", false, [1,5,0,0], () => (Promise.all([__webpack_require__.e(4300), __webpack_require__.e(4178), __webpack_require__.e(432), __webpack_require__.e(4719), __webpack_require__.e(7528), __webpack_require__.e(7875), __webpack_require__.e(6849), __webpack_require__.e(5681), __webpack_require__.e(3763), __webpack_require__.e(9020), __webpack_require__.e(7925), __webpack_require__.e(676), __webpack_require__.e(5302), __webpack_require__.e(6070), __webpack_require__.e(1422), __webpack_require__.e(600), __webpack_require__.e(3721)]).then(() => (() => (__webpack_require__(27925))))))),
	68901: () => (loadStrictVersion("default", "@moodys/mdc-frontend.theming.colors", false, [2,0,10,4], () => (Promise.all([__webpack_require__.e(3241), __webpack_require__.e(1115)]).then(() => (() => (__webpack_require__(91115))))))),
	85034: () => (loadStrictVersion("default", "@moodys/mdc-frontend.utils.html-sanitizer", false, [2,0,8,13], () => (Promise.all([__webpack_require__.e(5232), __webpack_require__.e(9390), __webpack_require__.e(1073)]).then(() => (() => (__webpack_require__(59390))))))),
	82353: () => (loadStrictVersion("default", "@mui/base", false, [1,5,0,0,,"alpha",105], () => (Promise.all([__webpack_require__.e(432), __webpack_require__.e(5335), __webpack_require__.e(5630), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(15630))))))),
	80579: () => (loadStrictVersion("default", "@moodys/mdc-frontend.services.fetcher", false, [2,0,10,2], () => (Promise.all([__webpack_require__.e(1083), __webpack_require__.e(6442)]).then(() => (() => (__webpack_require__(76442))))))),
	7097: () => (loadStrictVersion("default", "@moodys/mdc-frontend.utils.translation", false, [2,0,8,7], () => (__webpack_require__.e(8958).then(() => (() => (__webpack_require__(48958))))))),
	35140: () => (loadStrictVersion("default", "@moodys/mdc-frontend.widgets.error-page", false, [1,1,6,14], () => (Promise.all([__webpack_require__.e(7875), __webpack_require__.e(5088), __webpack_require__.e(1422)]).then(() => (() => (__webpack_require__(65088))))))),
	42531: () => (loadStrictVersion("default", "@module-federation/utilities", false, [4,1,5,0], () => (__webpack_require__.e(586).then(() => (() => (__webpack_require__(10586))))))),
	42734: () => (loadStrictVersion("default", "@moodys/mdc-toolbox.user.utils", false, [2,0,6,0], () => (__webpack_require__.e(1232).then(() => (() => (__webpack_require__(41232))))))),
	44845: () => (loadStrictVersion("default", "@mui/lab", false, [1,5,0,0,,"alpha",107], () => (Promise.all([__webpack_require__.e(432), __webpack_require__.e(7528), __webpack_require__.e(6849), __webpack_require__.e(9308), __webpack_require__.e(676), __webpack_require__.e(600)]).then(() => (() => (__webpack_require__(31007))))))),
	48156: () => (loadStrictVersion("default", "@moodys/mdc-shared-runtime", false, [2,0,12,1], () => (__webpack_require__.e(6793).then(() => (() => (__webpack_require__(16793))))))),
	62169: () => (loadStrictVersion("default", "@moodys/mdc-frontend.utils.event-bus", false, [1,2,1,0], () => (__webpack_require__.e(140).then(() => (() => (__webpack_require__(80140))))))),
	68443: () => (loadStrictVersion("default", "react-helmet-async", false, [1,1,3,0], () => (__webpack_require__.e(545).then(() => (() => (__webpack_require__(80545))))))),
	70208: () => (loadStrictVersion("default", "@emotion/css", false, [1,11,11,2], () => (__webpack_require__.e(9815).then(() => (() => (__webpack_require__(32196))))))),
	70771: () => (loadSingletonVersion("default", "react-router-dom", false, [1,6,7,0], () => (Promise.all([__webpack_require__.e(2648), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(92648))))))),
	82269: () => (loadStrictVersion("default", "@moodys/mdc-frontend.services.split", false, [2,0,9,13], () => (Promise.all([__webpack_require__.e(5156), __webpack_require__.e(5370)]).then(() => (() => (__webpack_require__(52989))))))),
	86912: () => (loadStrictVersion("default", "@moodys/mdc-nanofrontends-loader", false, [1,2,11,0], () => (Promise.all([__webpack_require__.e(6408), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(66408))))))),
	87908: () => (loadStrictVersion("default", "aws-rum-web", false, [1,1,19,0], () => (__webpack_require__.e(4078).then(() => (() => (__webpack_require__(24078))))))),
	91249: () => (loadStrictVersion("default", "@moodys/mdc-frontend.overlays.modal", false, [2,0,7,4], () => (__webpack_require__.e(2949).then(() => (() => (__webpack_require__(15330))))))),
	92681: () => (loadStrictVersion("default", "@moodys/mdc-frontend.helpers.micro-frontend-loader", false, [2,0,3,59], () => (__webpack_require__.e(318).then(() => (() => (__webpack_require__(77937))))))),
	5397: () => (loadSingleton("default", "./src/components/Layout/context", false, () => (__webpack_require__.e(7181).then(() => (() => (__webpack_require__(9562))))))),
	85156: () => (loadSingletonVersion("default", "@splitsoftware/splitio-react", false, [1,1,4,1], () => (__webpack_require__.e(8335).then(() => (() => (__webpack_require__(88335))))))),
	91422: () => (loadSingletonVersion("default", "@mui/private-theming", false, [1,5,0,0], () => (__webpack_require__.e(4888).then(() => (() => (__webpack_require__(14888))))))),
	80676: () => (loadSingletonVersion("default", "react-dom", false, [1,18,3,1], () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(40961))))))),
	10600: () => (loadStrictVersion("default", "@mui/base", false, [1,5,0,0,,"alpha",105], () => (Promise.all([__webpack_require__.e(5681), __webpack_require__.e(5335), __webpack_require__.e(3188)]).then(() => (() => (__webpack_require__(73188))))))),
	86259: () => (loadSingletonVersion("default", "@emotion/react/jsx-runtime", false, [1,11,10,5], () => (Promise.all([__webpack_require__.e(2389), __webpack_require__.e(2445)]).then(() => (() => (__webpack_require__(2445)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"579": [
		80579
	],
	"600": [
		10600
	],
	"676": [
		80676
	],
	"1073": [
		61073
	],
	"1150": [
		21150
	],
	"1422": [
		91422
	],
	"1780": [
		5397
	],
	"2353": [
		82353
	],
	"2726": [
		68901,
		85034
	],
	"4477": [
		7097,
		35140,
		42531,
		42734,
		44845,
		48156,
		62169,
		68443,
		70208,
		70771,
		82269,
		86912,
		87908,
		91249,
		92681
	],
	"5080": [
		50318
	],
	"5156": [
		85156
	],
	"5302": [
		85302
	],
	"6070": [
		36070
	],
	"6259": [
		86259
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}